import React from 'react';
import styles from './StatTiles.module.css';
import accents from '../../appointment/components/moduleCard/accents.module.css';

/**
 * Blocos de fato (ícone colorido, rótulo em caixa alta e valor), no mesmo
 * desenho dos blocos do card de atendimento. Usado no resumo do cabeçalho da
 * ficha e nos números da seção Agendamentos.
 *
 * `items`: [{ key, icon, label, value, detail?, accent?, onClick? }]. Com
 * `onClick` o bloco vira botão (atalho para a seção correspondente).
 */
const StatTiles = ({ items, className = '' }) => (
  <div className={`${styles.tiles} ${className}`.trim()}>
    {items.map((item) => {
      const classes = [
        styles.tile,
        accents[item.accent] || accents.blue,
        item.onClick ? styles.tileButton : '',
      ].join(' ');
      const content = (
        <>
          <span className={styles.tileIcon}>{item.icon}</span>
          <span className={styles.tileContent}>
            <span className={styles.tileLabel}>{item.label}</span>
            <span className={styles.tileValue}>{item.value}</span>
            {item.detail && <span className={styles.tileDetail}>{item.detail}</span>}
          </span>
        </>
      );
      return item.onClick ? (
        <button key={item.key || item.label} type="button" className={classes} onClick={item.onClick}>
          {content}
        </button>
      ) : (
        <div key={item.key || item.label} className={classes}>
          {content}
        </div>
      );
    })}
  </div>
);

export default StatTiles;
